import {Box, Grid, Slot, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useBinaryState} from '@yandex-delivery/hooks'
import {type ReactElement} from 'react'

import {Body, ToggleTitle} from '../../components/desktop'
import * as classes from '../Address/components/AddressWidget/AddressWidget@desktop.classes'
import {renderWidget} from '../index@desktop'
import {type SectionProps as Props} from '../types'
import {groupByOptionType, toHeader} from './Options@desktop.utils'

export function OptionsDesktop(props: Props): ReactElement {
  const {headers, children, hidden} = groupByOptionType(props)
  const hasHiddenOptions = hidden?.length > 0
  const i18n = useI18n()
  const [isOpen, _open, _close, toggle] = useBinaryState(false)

  return (
    <Grid xs={12} item>
      <Paper padding="none" radius="L">
        <Grid container>
          {headers.map(header => (
            <Grid key={header.widget_id} xs={12} item>
              <Box ml="s" mt="s">
                {renderWidget(toHeader(header))}
              </Box>
            </Grid>
          ))}

          <Grid xs={12} item>
            <div className={classes.root}>
              <Body
                lead={
                  <>
                    <Typography mt="s" thickness="medium" variant="body2">
                      {i18n('cargo.create.default_requirements.options', 'Опции')}
                    </Typography>

                    {hasHiddenOptions ? (
                      <ToggleTitle
                        isOpened={isOpen}
                        onClick={toggle}
                        title={i18n('cargo.create.additional-requirements.title', 'Дополнительно')}
                      />
                    ) : null}
                  </>
                }
                tail={<>{children.map(renderWidget)}</>}
              />

              {hasHiddenOptions && isOpen && (
                <Body
                  lead={
                    <Typography color="main" mt="m" thickness="medium" variant="caption1">
                      {i18n('cargo.create.return-requirements.title', 'Возврат')}
                    </Typography>
                  }
                  tail={
                    <>
                      {gapSlot}
                      {hidden.map(renderWidget)}
                    </>
                  }
                />
              )}
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}

// пустой слот нужен для того, чтобы правильно отработал CSS и в следующем слоте отрисовался разделитель
const gapSlot = <Slot style={{display: 'none'}} />
